import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import * as AlertingActions from '@core-app/state/alerting/alerting.actions';
import { MonitorType } from '@enums';
import { FormGroup } from '@angular/forms';
import { Monitor } from '@interfaces';
import { Store } from '@ngrx/store';

@Component({
  selector: 'fip-reduction-in-the-value-of-oee-below-x-modal',
  templateUrl: './reduction-in-the-value-of-oee-below-x-modal.component.html',
  styleUrl: './reduction-in-the-value-of-oee-below-x-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ReductionInTheValueOfOEEBelowXModalComponent {
  private readonly _store = inject(Store);

  /**
   * Handles form submission when user creates a monitor.
   *
   * Receives the form group from the form component and dispatches an action
   * to upsert the monitor with the configured settings.
   */
  onFormSubmit(formGroup: FormGroup): void {
    const formValue = formGroup.value;

    const monitor: Monitor = {
      partitionKey: 'v1',
      monitorType: MonitorType.ReductionInTheValueOfOEEBelowXPercent,
      name: formValue.name,
      targetPercentage: formValue.targetPercentage,
      initialQueryDate: formValue.initialQueryDate.toISOString(),
      recipientGroupId: formValue.recipientsGroupId,
      approversGroupId: formValue.approversGroupId,
      companyId: formValue.companyId,
      priorityLevel: 'P2',
    };

    this._store.dispatch(AlertingActions.upsertMonitor({ monitor }));
  }
}
